import React, { useEffect, useState, useContext } from "react";
import { subcatHierarcyContext } from "../context/SubcatHierarcyContext";
import { categoryHierarcyContext } from "../context/CategoryHierarcyContext";
import { assortmentHierarcyContext } from "../context/AssortmentHierarcyContext";
import { fixtureContext } from "../context/FixtureContext";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";
import { useHistory } from "react-router-dom";

const AddPlanogram = () => {
    const { fetchSUBCategoryHierarcyAction, subcategoryHierarcy } = useContext(
        subcatHierarcyContext
    );

    const { fetchCategoryHierarcyAction, categoryHierarcy } = useContext(
        categoryHierarcyContext
    );

    const { fetchAssortmentHierarcyAction, assortmentHierarcy } = useContext(
        assortmentHierarcyContext
    );

    const { fetchAssortPlanogramAction, getplano, saveAssortmentPlanogramAction, fetchOnlyPlanogramAction, onlyplano } = useContext(fixtureContext);

    const history = useHistory()
    //OKTA
    const { tokenVal } = useLoginfo()

    useEffect(() => {

        fetchCategoryHierarcyAction(tokenVal);
        fetchSUBCategoryHierarcyAction(tokenVal);
        fetchAssortmentHierarcyAction(tokenVal)
        fetchAssortPlanogramAction(tokenVal)
        fetchOnlyPlanogramAction(tokenVal)

    }, [tokenVal]);
    const [unmappedCTGAssortment, setUnmappedCTGAssortment] = useState([]);    
    const [formData, setFormData] = useState({
        ASSORTMENT_ID: "",
        ASSORTMENT_SUB: "",
        CAT_ID: "",
        POG_KEY: ""
    });

    //handle form change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    useEffect(() => {
        unmappedAssortment(); 
    },[assortmentHierarcy])
   const  unmappedAssortment =() =>{
        setUnmappedCTGAssortment(assortmentHierarcy.sort((a, b) => parseInt(a.ASSORTMENT_ID) - parseInt(b.ASSORTMENT_ID)).filter((i)=>i.PLANO_NBR.toString() === ""));
    }
  
    const [flag, setflag] = useState(false);
    //handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();

        //add Assortment_planogram
        if (flag) {
            console.log({ ...formData });

            saveAssortmentPlanogramAction({ ...formData }, tokenVal, history);
        }
    };

    //handle form cancel
    const handleCancel = (e) => {
        window.location.href = "/view-planogram";
    };

    return (
        <div>
            <Breadcrumbs
                separator="›"
                aria-label="breadcrumb"
                style={{ marginLeft: "15px" }}
            >
                <Link underline="hover" color="inherit" href="/view-planogram">
                    View Assortment Planogram
                </Link>
                <Link
                    underline="hover"
                    color="text.primary"
                    href="/assign-planogram"
                    aria-current="page"
                >
                    Add Assortment Planogram
                </Link>
            </Breadcrumbs>
            <h2 style={{ textAlign: "center" }}>Add Assortment Planogram</h2>

            <form className="flex-container" onSubmit={handleSubmit}>
                <div style={{ marginLeft: "15px" }}>

                    <div className="flex-container">
                        <label className="first-box" style={{ marginRight: "10px" }}>
                            Category ID-Category Description
                        </label>

                        <TextField
                            size="small"
                            required={flag}
                            name="ASSORTMENT_SUB"
                            value={formData.ASSORTMENT_SUB}
                            onChange={handleChange}
                            className="depart"
                            id="outlined-select-currency"
                            select
                        >
                            {categoryHierarcy.sort((a, b) => parseInt(a.ASSORTMENT_SUB) - parseInt(b.ASSORTMENT_SUB)).filter((i)=> unmappedCTGAssortment.some(item => item.ASSORTMENT_ID === i.ASSORTMENT_ID)).map((option) => (
                                <MenuItem
                                    key={option.ASSORTMENT_SUB}
                                    value={option.ASSORTMENT_SUB}
                                >
                                    {option.ASSORTMENT_SUB}-{option.ASSORTMENT_SUB_DESC}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>

                    <div className="flex-container">
                        <label className="first-box" style={{ marginRight: "10px" }}>
                            Sub Category Id-Sub Category Description
                        </label>

                        <TextField
                            size="small"
                            required={flag}
                            name="CAT_ID"
                            value={formData.CAT_ID}
                            onChange={handleChange}
                            className="depart"
                            id="outlined-select-currency"
                            select
                        >
                            {subcategoryHierarcy.sort((a, b) => parseInt(a.CAT_ID) - parseInt(b.CAT_ID)).filter((i) => i.ASSORTMENT_SUB == formData.ASSORTMENT_SUB).map((option) => (
                                <MenuItem key={option.CAT_ID} value={option.CAT_ID}>
                                    {option.CAT_ID}-{option.CAT_DS}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>

                    <div className="flex-container">
                        <label className="">Assortment ID-Assortment Description</label>

                        <TextField
                            size="small"
                            required={flag}
                            name="ASSORTMENT_ID"
                            value={formData.ASSORTMENT_ID}
                            onChange={handleChange}
                            className="depart"
                            id="outlined-select-currency"
                            select
                        >
                            {assortmentHierarcy.sort((a, b) => parseInt(a.ASSORTMENT_ID) - parseInt(b.ASSORTMENT_ID)).filter((i) => i.SUB_CATEGORY_ID == formData.CAT_ID && i.SUB_CATEGORY_ID.length > 0 && i.POG_KEY == 0).map((option) => (
                                <MenuItem
                                    key={option.ASSORTMENT_ID}
                                    value={option.ASSORTMENT_ID}
                                >
                                    {option.ASSORTMENT_ID}-{option.ASSORTMENT_DESC}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>

                    <div
                        style={{
                            marginTop: "100px",
                            display: "flex",
                        }}
                    >
                        <div className="save-btn">
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                onClick={(e) => setflag(true)}
                                size="large"
                            >
                                <span className="cat-radio">Save</span>
                            </Button>
                        </div>
                        <div>
                            <Button
                                className=""
                                variant="contained"
                                color="error"
                                onClick={handleCancel}
                                size="large"
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>

                <div style={{ marginRight: "15px" }}>
                    <label className="">Planograms</label>
                    <div className="planogram assignplan" style={{ height: "280px" }}>

                        {onlyplano.map((item) => {
                            return (<label key={item.POG_KEY} style={{ marginBottom: "11px", fontSize: "0.95rem", marginRight: "0px" }}>
                                <input style={{ width: "15px", marginRight: "5px" }}
                                    type="radio"
                                    name="POG_KEY"
                                    value={item.POG_KEY}
                                    onChange={handleChange}
                                />
                                {item.PLANO_NBR}, {item.PLANO_NAME}, {item.SERIAL_NUM}
                            </label>)
                        })}
                    </div>
                </div>

            </form>
        </div>
    );
};

export default AddPlanogram;
